import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3xs1,
    GridItem3xs6,
    GridItem4,
    GridItem4xs6,
    GridItem4xs10,
    GridItem4xs12,
    GridItem5xs6,
    GridItem7xs10,
    GridItem8xs10,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    InformacoesOpcionaisNaoAfetamCalculo
} from '../cliente-form/ClienteComp'

import {
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    TipoRecursoFinanceiro,
    IconButtonClearEntradaDadosRecursosFinanceiros,
    Valor,
    ValorAporteDividendos,
    ValorAporteEmpresa,
    TipoPeriodicidadeAporteDividendos,
    MesAnoInicialAporteDividendos,
    MesAnoFinalAporteDividendos,
    AporteDividendosAteAposentadoria,
    AporteOriundoReceitaMensal,
    HelpAporteOriundoReceitaMensal,
    AporteOriundoRealocacaoCarteiraInvestimentos,
    HelpAporteOriundoRealocacaoCarteiraInvestimentos,
    RecursoFinanceiroOrigemRealocacaoCarteiraInvestimentos,
    ControlarAportes,
    DiaAporte,
    PercRecursosFinanceirosCliente,
    PercRecursosFinanceirosConjuge,
    NaoInventariar,
    HelpNaoInventariar,
    PercDespesasAdvocaticias,
    PercCustasJudiciais,
    PercInventarioItcmd,
    NaoConsiderarGarantiaMorteInvalidezCliente,
    NaoConsiderarGarantiaMorteInvalidezConjuge,
    HelpNaoConsiderarGarantiaMorteInvalidez,
    TipoRegimeTributacao,
    NomeFundo,
    CnpjFundo,
    Instituicao,
    DataInicioRecursoFinanceiro,
    PercRentabilidadeMesRecursoFinanceiro,
    PercCDIMesRecursoFinanceiro,
    PercRentabilidadeAnoRecursoFinanceiro,
    PercCDIAnoRecursoFinanceiro,
    PercRentabilidade12MRecursoFinanceiro,
    PercCDI12MRecursoFinanceiro,
    PercRentabilidade24MRecursoFinanceiro,
    PercCDI24MRecursoFinanceiro,
    Vencimento,
    NomeAcao,
    PercRentabilidadeAnualRecursoFinanceiro,
    TipoMomentoTributacaoIR,
    PercIR,
    TempoMinimoEntreAportesResgatesCalculoIRAnos,
    TaxaInflacaoAnualRecursoFinanceiro,
    //TaxaAnual,
    DescricaoOutros,
    HelpDescricaoOutros,
    Observacao,
} from './GarantiasCompRecursosFinanceiros'



const GarantiasFormRecursosFinanceirosItem = ({ values, handleChange, setFieldValue, arrayHelpers, linhaTipoLicenca,
    tipoRecursoFinanceiroSelecionado, item, ind/*, jsonConfiguracao*/, simplificado}) => {

    return (
       
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <GridContainer>
                    <GridItem8xs10>
                        <TipoRecursoFinanceiro
                            TextFieldNumberSelectTipoRecursoFinanceiro={
                                TextFieldNumberSelectDestaque
                            }
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                            //jsonConfiguracao={jsonConfiguracao}
                        />
                    </GridItem8xs10>

                    <GridItem3xs1 />

                    <GridItem1>
                        <IconButtonClearEntradaDadosRecursosFinanceiros
                            values={values}
                            setFieldValue={setFieldValue}
                            item={item}
                            ind={ind}
                            arrayHelpers={arrayHelpers}
                            simplificado={simplificado}
                        />
                    </GridItem1>
                </GridContainer>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBodyEntradaDados
                style={{
                    display: 
                        item.tipoRecursoFinanceiro
                            ? "block"
                            : "none"
                }} 
            >
                <GridContainer>
                    {tipoRecursoFinanceiroSelecionado.informaReservaAtual !== "0" && (
                        <GridItem4xs6>
                            <Valor
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                                tipoRecursoFinanceiroSelecionado={
                                    tipoRecursoFinanceiroSelecionado
                                }
                            />
                        </GridItem4xs6>
                    )}

                    {tipoRecursoFinanceiroSelecionado.informaAporteDividendos === "S" && (
                        <GridItem4xs6>
                            <ValorAporteDividendos
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                                tipoRecursoFinanceiroSelecionado={
                                    tipoRecursoFinanceiroSelecionado
                                }
                            />
                        </GridItem4xs6>
                    )}

                    {tipoRecursoFinanceiroSelecionado.informaAporteEmpresa === "S" && (
                        <GridItem4xs6>
                            <ValorAporteEmpresa
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4xs6>
                    )}

                    {(
                        (
                            item.valorAporteDividendos &&
                            round(item.valorAporteDividendos, 2) !== 0
                        ) || 
                        (
                            item.valorAporteEmpresa &&
                            round(item.valorAporteEmpresa, 2) !== 0
                        )
                    )
                        ?
                            <>
                                <GridItem4xs12>
                                    <TipoPeriodicidadeAporteDividendos
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem4xs12>
                                <GridItem4xs6>
                                    <MesAnoInicialAporteDividendos
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem4xs6>

                                {!item.aporteDividendosAteAposentadoria &&
                                item.tipoPeriodicidadeAporteDividendos !== HARDCODE.idTipoPeriodicidadeUnica && (
                                    <GridItem4xs6>
                                        <MesAnoFinalAporteDividendos
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                        />
                                    </GridItem4xs6>
                                )}

                                {tipoRecursoFinanceiroSelecionado.informaPercRentabilidadeRecursoFinanceiro === "S" &&
                                linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                                    <>
                                        <GridItem4xs6>
                                            <PercRentabilidadeAnualRecursoFinanceiro
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                                labelCurto={false}
                                            />
                                        </GridItem4xs6>

                                        {(item.percRentabilidadeAnualRecursoFinanceiro ||
                                        item.percRentabilidadeAnualRecursoFinanceiro === 0) && (
                                            <GridItem4xs6>
                                                <TaxaInflacaoAnualRecursoFinanceiro
                                                    item={item}
                                                    ind={ind}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem4xs6>
                                        )}

                                        {item.percRentabilidadeAnualRecursoFinanceiro && (
                                            <>
                                                <GridItem4xs6>
                                                    <TipoMomentoTributacaoIR
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem4xs6>

                                                {(item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRComeCotas ||
                                                item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRPGBL ||
                                                item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                                item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                                    <GridItem4xs6>
                                                        <PercIR
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4xs6>
                                                )}

                                                {(item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                                item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                                    <GridItem4xs6>
                                                        <TempoMinimoEntreAportesResgatesCalculoIRAnos
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4xs6>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}

                                {item.tipoPeriodicidadeAporteDividendos !== HARDCODE.idTipoPeriodicidadeUnica && (
                                    <GridItem12>
                                        <AporteDividendosAteAposentadoria
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            tipoRecursoFinanceiroSelecionado={
                                                tipoRecursoFinanceiroSelecionado
                                            }
                                        />
                                    </GridItem12>
                                )}

                                {tipoRecursoFinanceiroSelecionado.informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos === "S" &&
                                linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' &&
                                !item.aporteOriundoRealocacaoCarteiraInvestimentos && (
                                    <>
                                        <GridItem7xs10>
                                            <AporteOriundoReceitaMensal
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem7xs10>
                                        
                                        <GridItem1>
                                            <HelpAporteOriundoReceitaMensal/>
                                        </GridItem1>
                                    </>
                                )}
                                
                                {tipoRecursoFinanceiroSelecionado.informaAporteOriundoReceitaMensalOuRealocacaoCarteiraInvestimentos === "S" &&
                                linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' &&
                                !item.aporteOriundoReceitaMensal && (
                                    <>
                                        <GridItem10>
                                            <AporteOriundoRealocacaoCarteiraInvestimentos
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem10>
                                        
                                        <GridItem1>
                                            <HelpAporteOriundoRealocacaoCarteiraInvestimentos/>
                                        </GridItem1>
                                    </>
                                )}

                                {item.aporteOriundoRealocacaoCarteiraInvestimentos && (
                                    <GridItem10>
                                        <RecursoFinanceiroOrigemRealocacaoCarteiraInvestimentos
                                            values={values}
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                        />
                                    </GridItem10>
                                )}
                            </>
                        :
                            tipoRecursoFinanceiroSelecionado.informaPercRentabilidadeRecursoFinanceiro === "S" &&
                            linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                                <>
                                    <GridItem4xs6>
                                        <PercRentabilidadeAnualRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem4xs6>

                                    {(item.percRentabilidadeAnualRecursoFinanceiro ||
                                    item.percRentabilidadeAnualRecursoFinanceiro === 0) && (
                                        <GridItem4xs6>
                                            <TaxaInflacaoAnualRecursoFinanceiro
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem4xs6>
                                    )}

                                    {item.percRentabilidadeAnualRecursoFinanceiro && (
                                        <>
                                            <GridItem4xs6>
                                                <TipoMomentoTributacaoIR
                                                    item={item}
                                                    ind={ind}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem4xs6>

                                            {(item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRComeCotas ||
                                            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRPGBL ||
                                            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                                <GridItem4xs6>
                                                    <PercIR
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem4xs6>
                                            )}

                                            {(item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                                <GridItem4xs6>
                                                    <TempoMinimoEntreAportesResgatesCalculoIRAnos
                                                        item={item}
                                                        ind={ind}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem4xs6>
                                            )}
                                        </>
                                    )}
                                </>
                            )
                    }
                </GridContainer>
                
                <CardGridDividerElementos/>
                
                {/*{tipoRecursoFinanceiroSelecionado.informaInstituicao === "S" && (*/}
                <GridItem10>
                        <Instituicao
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem10>
                {/*})}*/}

                <GridContainer>
                    <GridItem10>
                        <DescricaoOutros
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem10>
                    <GridItem2>
                        <HelpDescricaoOutros/>
                    </GridItem2>
                </GridContainer>

                {item.valorAporteDividendos && round(item.valorAporteDividendos, 2) !== 0 && (
                    <>
                        <CardGridDividerElementos/>

                        <GridContainer>
                            <GridItem4xs6>
                                <ControlarAportes
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs6>

                            {item.controlarAportes && (
                                <GridItem4>
                                    <DiaAporte
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem4>
                            )}
                        </GridContainer>
                    </>
                )}

                <CardGridDividerElementos/>
                
                <GridContainer>
                    {item.familiar === HARDCODE.idFamiliarCasal && (
                        <>
                            <GridItem3xs6>
                                <PercRecursosFinanceirosCliente
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem3xs6>
                            <GridItem3xs6>
                                <PercRecursosFinanceirosConjuge
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem3xs6>
                        </>
                    )}

                    {/*(*/tipoRecursoFinanceiroSelecionado.inventario === "S"/* ||
                    (
                        tipoRecursoFinanceiroSelecionado.inventario ===
                            HARDCODE.inventarioPrevidenciaPrivada &&
                        jsonConfiguracao &&
                        jsonConfiguracao.considerarPrevidenciaPrivadaInventario
                    ))*/ && (
                        <>
                            <GridItem4xs10>
                                <NaoInventariar
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs10>
                            <GridItem1>
                                <HelpNaoInventariar />
                            </GridItem1>
                        </>
                    )}
                </GridContainer>

                <GridContainer>
                    {tipoRecursoFinanceiroSelecionado.somenteITCMD !== "S" && (
                        <>
                            <GridItem4xs10>
                                <PercDespesasAdvocaticias
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs10>
                            <GridItem4xs10>
                                <PercCustasJudiciais
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs10>
                        </>
                    )}
                    <GridItem4xs10>
                        <PercInventarioItcmd
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem4xs10>
                </GridContainer>

                {(item.familiar === HARDCODE.idFamiliarCliente ||
                item.familiar === HARDCODE.idFamiliarConjuge ||
                item.familiar === HARDCODE.idFamiliarCasal) && (
                    <GridContainer>
                        <GridItem10>
                            <NaoConsiderarGarantiaMorteInvalidezCliente
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem10>

                        {dadosCompletosConjuge(values, true) && (
                            <GridItem10>
                                <NaoConsiderarGarantiaMorteInvalidezConjuge
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem10>
                        )}
                        <GridItem1>
                            <HelpNaoConsiderarGarantiaMorteInvalidez/>
                        </GridItem1>
                    </GridContainer>
                )}

                {(item.DataInicioRecursoFinanceiro ||
                item.percRentabilidadeMesRecursoFinanceiro ||
                item.vencimento ||
                tipoRecursoFinanceiroSelecionado.informaRegimeTributacao === "S" ||
                tipoRecursoFinanceiroSelecionado.informaNomeFundo === "S" || 
                tipoRecursoFinanceiroSelecionado.informaCnpjFundo === "S" ||
                //tipoRecursoFinanceiroSelecionado.informaInstituicao === "S" ||
                tipoRecursoFinanceiroSelecionado.informaVencimento === "S" || 
                tipoRecursoFinanceiroSelecionado.informaNomeAcao === "S"/* ||
                tipoRecursoFinanceiroSelecionado.informaTaxaAnual === "S"*/) &&
                linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                    <>
                        <CardGridDividerElementos/>

                        <InformacoesOpcionaisNaoAfetamCalculo />

                        <GridContainer>
                            {tipoRecursoFinanceiroSelecionado.informaRegimeTributacao === "S" && (
                                <GridItem7xs10>
                                    <TipoRegimeTributacao
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem7xs10>
                            )}
                            
                            {tipoRecursoFinanceiroSelecionado.informaNomeFundo === "S" && (
                                <GridItem7xs10>
                                    <NomeFundo
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem7xs10>
                            )}

                            {tipoRecursoFinanceiroSelecionado.informaCnpjFundo === "S" && (
                                <GridItem7xs10>
                                    <CnpjFundo
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem7xs10>
                            )}

                            {(item.DataInicioRecursoFinanceiro || item.percRentabilidadeMesRecursoFinanceiro || item.vencimento) &&
                            linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                                <GridContainer>
                                    <GridItem5xs6>
                                        <DataInicioRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            setFieldValue={setFieldValue}
                                        />
                                    </GridItem5xs6>

                                    <GridItem5xs6/>

                                    <GridItem5xs6>
                                        <PercRentabilidadeMesRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem5xs6>

                                    <GridItem5xs6>
                                        <PercCDIMesRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem5xs6>
                                    
                                    <GridItem5xs6>
                                        <PercRentabilidadeAnoRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem5xs6>

                                    <GridItem5xs6>
                                        <PercCDIAnoRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem5xs6>
                                    
                                    <GridItem5xs6>
                                        <PercRentabilidade12MRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem5xs6>

                                    <GridItem5xs6>
                                        <PercCDI12MRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem5xs6>
                                    
                                    <GridItem5xs6>
                                        <PercRentabilidade24MRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem5xs6>

                                    <GridItem5xs6>
                                        <PercCDI24MRecursoFinanceiro
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                            labelCurto={false}
                                        />
                                    </GridItem5xs6>
                                </GridContainer>
                            )}

                            {tipoRecursoFinanceiroSelecionado.informaVencimento === "S" && (
                                <GridItem5xs6>
                                    <Vencimento
                                        item={item}
                                        ind={ind}
                                        setFieldValue={setFieldValue}
                                    />
                                </GridItem5xs6>
                            )}

                            {tipoRecursoFinanceiroSelecionado.informaNomeAcao === "S" && (
                                <GridItem7xs10>
                                    <NomeAcao
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem7xs10>
                            )}

                            {/*tipoRecursoFinanceiroSelecionado.informaTaxaAnual === "S" && (
                                <GridItem4>
                                    <TaxaAnual
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem4>
                            )*/}
                        </GridContainer>
                    </>
                )}

                <CardGridDividerElementos/>

                <GridContainer>
                    <GridItem12>
                        <Observacao
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem12>
                </GridContainer>
            </CardGridDivBodyEntradaDados>
        </CardGridEntradaDados>
    )
}

export default GarantiasFormRecursosFinanceirosItem